import React from 'react';

import Popup from '../Popup/Popup';
import ConfirmationPopup from '../../../ConfirmationPopup/ConfirmationPopup';
import QuestionChoicesTagging from './components/QuestionChoicesTagging/QuestionChoicesTagging';
import ResearchCostIncreasedPopup from './components/ResearchCostIncreased/ResearchCostIncreased';

import { SURVEY_BUILDER_POPUP_TYPES } from '../../helpers/constants';

export default ({ api, actions, surveyBuilderPopup }) => {
  if (surveyBuilderPopup.type === SURVEY_BUILDER_POPUP_TYPES.CONFIRMATION) {
    return (
      <Popup
        component={
          <ConfirmationPopup
            onClick={surveyBuilderPopup.onClick}
            onClose={surveyBuilderPopup.onClose}
            onDontShowAnymoreChecked={
              surveyBuilderPopup.onDontShowAnymoreChecked
            }
            title={surveyBuilderPopup.title}
            description={surveyBuilderPopup.description}
            warning={surveyBuilderPopup.warning}
          />
        }
        onClose={() => {}}
      />
    );
  }

  if (
    surveyBuilderPopup.type ===
    SURVEY_BUILDER_POPUP_TYPES.PROFILE_QUESTION_CATEGORY
  ) {
    return (
      <Popup
        component={
          <QuestionChoicesTagging
            api={api}
            actions={actions}
            surveyBuilderPopup={surveyBuilderPopup}
          />
        }
        onClose={() => {}}
      />
    );
  }

  if (
    surveyBuilderPopup.type ===
    SURVEY_BUILDER_POPUP_TYPES.RESEARCH_COST_INCREASED
  ) {
    return (
      <Popup
        component={
          <ResearchCostIncreasedPopup
            onClick={surveyBuilderPopup.onClick}
            onClose={surveyBuilderPopup.onClose}
          />
        }
        onClose={() => {}}
      />
    );
  }

  return null;
};
